import Pagination from 'common/components/table/pagination'

type Props = {
  total: number
  page: number
  pageSize: number
  onPageChange: (page: number) => void
  onPageSizeChange: (limit: number) => void
  className?: string
}

const ContentLibraryPagination = ({
  total,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  className,
}: Props) => {
  const pageIndex = page
  const pageCount = Math.ceil(total / pageSize)

  return (
    <Pagination
      className={className}
      pageIndex={pageIndex}
      pageSize={pageSize}
      setPageSize={(newPageSize) => {
        onPageSizeChange(newPageSize)
      }}
      pageCount={pageCount}
      totalRowCount={total}
      gotoPage={(pageIdx) => onPageChange(pageIdx)}
      canPreviousPage={pageIndex > 0}
      previousPage={() => {
        if (pageIndex > 0) {
          onPageChange(pageIndex - 1)
        }
      }}
      nextPage={() => {
        if (pageIndex < pageCount - 1) {
          onPageChange(pageIndex + 1)
        }
      }}
      canNextPage={pageIndex < pageCount - 1}
    />
  )
}

export default ContentLibraryPagination
